import { trackingService } from '@monthio/react-components'
import { MemoryStorage } from './MemoryStorage'

export class StorageService {
	#storage: Storage

	constructor() {
		if (isPersistedStorageSupported('localStorage')) {
			this.#storage = window.localStorage
			return
		}

		if (isPersistedStorageSupported('sessionStorage')) {
			trackingService.trackEvent('flowWithSessionStorage')
			this.#storage = window.sessionStorage
			return
		}

		this.#storage = new MemoryStorage()
	}

	public readonly get = <T = any>(key: string): T | null => {
		const value = this.#storage.getItem(key)
		if (value) {
			return JSON.parse(value)
		}
		return null
	}

	public readonly set = (key: string, value: any, raw = false) => {
		if (!raw) {
			this.#storage.setItem(key, JSON.stringify(value))
			return
		}

		this.#storage.setItem(key, value)
	}

	public readonly remove = (key: string) => {
		this.#storage.removeItem(key)
	}

	public readonly clear = () => {
		// TODO: collect all keys and remove them one by one
		// this.#storage.clear()
	}
}

const TEST_KEY = '__test'
const isPersistedStorageSupported = (
	name: 'localStorage' | 'sessionStorage',
) => {
	try {
		window[name].setItem(TEST_KEY, '1')
		window[name].removeItem(TEST_KEY)
		return true
	} catch (e) {
		return false
	}
}
